import { useState } from "react";
import "./ShareButton.scss";
import { FaShareAlt, FaWhatsapp, FaEnvelope, FaTelegramPlane, FaLink } from "react-icons/fa";
import { FaFacebookF, FaXTwitter, FaLinkedinIn } from "react-icons/fa6";

const ShareButton = ({ id }) => {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const shareLink = `${window.location.origin}${window.location.pathname}?product=${id}`;

  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Check this out",
          text: "Have a look at this product!",
          url: shareLink,
        });
      } catch (error) {
        console.log("Share cancelled");
      }
    } else {
      setOpen(true);
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(shareLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="share-container">

      {/* Share button */}
      <button onClick={handleNativeShare} className="share-button">
        <FaShareAlt />
      </button>

      {/* Desktop Popup */}
      {open && !navigator.share && (
        <>
          <div className="share-backdrop" onClick={() => setOpen(false)}></div>

          <div className="share-popup">
            <h4>Share</h4>

            <div className="share-options">

              <a href={`https://wa.me/?text=${encodeURIComponent(shareLink)}`} target="_blank" rel="noreferrer">
                <FaWhatsapp /> WhatsApp
              </a>

              <a href={`mailto:?subject=Check this out&body=${encodeURIComponent(shareLink)}`}>
                <FaEnvelope /> Email
              </a>

              <a href={`https://t.me/share/url?url=${encodeURIComponent(shareLink)}`} target="_blank" rel="noreferrer">
                <FaTelegramPlane /> Telegram
              </a>

              <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareLink)}`} target="_blank" rel="noreferrer">
                <FaFacebookF /> Facebook
              </a>

              <a href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(shareLink)}`} target="_blank" rel="noreferrer">
                <FaXTwitter /> Twitter / X
              </a>

              <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareLink)}`} target="_blank" rel="noreferrer">
                <FaLinkedinIn /> LinkedIn
              </a>

              <button onClick={handleCopy}>
                <FaLink /> {copied ? "Copied!" : "Copy Link"}
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ShareButton;







// LINK COPY CODE
// import { useState } from "react";
// import "./ShareButton.scss";
// import { FaShareAlt } from "react-icons/fa";

// const ShareButton = ({ id }) => {
//   const [copied, setCopied] = useState(false);

//   const handleShare = () => {
//   const shareLink = `${window.location.origin}${window.location.pathname}?product=${id}`;

//   navigator.clipboard.writeText(shareLink);
//   setCopied(true);

//   setTimeout(() => setCopied(false), 2000);
// };

//   return (
//     <div className="share-container">
//       <button onClick={handleShare} className="share-button">
//         <FaShareAlt />
//       </button>

//       {copied && <span className="copied-text">Link copied!</span>}
//     </div>
//   );
// };

// export default ShareButton;
